'use client';

import clsx from 'clsx';
import type { ForwardedRef, ReactNode } from 'react';
import { forwardRef } from '../../forward-ref.js';
import { withStyleProps } from '../../with-style-props.js';
import type { CommonProps } from '../types.js';

export interface CodeProps extends CommonProps {
  /** The inline code content to display. */
  children: ReactNode;
}

function Code({ children, UNSAFE_className, UNSAFE_style, ...props }: CodeProps, ref: ForwardedRef<HTMLElement>) {
  return (
    <code {...props} ref={ref} className={clsx('cim-code', UNSAFE_className)} style={UNSAFE_style}>
      {children}
    </code>
  );
}

/**
 * Displays short, inline code snippets.
 *
 * See [code usage guidelines](https://ui.cimpress.io/components/code).
 */
const _Code = withStyleProps(forwardRef(Code), 'Code');
export { _Code as Code };
